import React, {useEffect, useState} from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
	TextField,
	Checkbox,
	FormControlLabel,
	Button,
	Box,
	Typography,
	Chip,
	Stack,
	Card,
	CardContent,
} from '@mui/material'
import { useNavigate } from 'react-router'
import { usePostVacancyMutation } from '../store/api/vacanciesApi'
import {PostVacancyReq} from '../types'
import VacancyForm from '../components/VacancyForm'



const AddVacancyForm = () => {
	return <VacancyForm/>
}

export default AddVacancyForm
